import type { ReactNode } from 'react';
import { cx } from '../lib/cx';
import { Icon } from '../icons/Icon';

export interface StatCardProps {
  label: ReactNode;
  value: ReactNode;
  /** Trend direction for the delta line. */
  trend?: 'up' | 'down' | 'flat';
  delta?: ReactNode;
  /** e.g. a <Sparkline/>. Rendered under the value. */
  chart?: ReactNode;
  className?: string;
}

/** KPI tile for the dashboard "is it working?" strip (brief §7.5). */
export function StatCard({ label, value, trend, delta, chart, className }: StatCardProps) {
  return (
    <div className={cx('tc-card', 'tc-stat', className)}>
      <div className="tc-stat__label">{label}</div>
      <div className="tc-stat__value">{value}</div>
      {delta != null && (
        <div className={cx('tc-stat__foot', trend && `tc-stat__foot--${trend}`)}>
          {trend === 'up' && <Icon name="arrow-up" size={14} strokeWidth={2.5} />}
          {trend === 'down' && <Icon name="arrow-down" size={14} strokeWidth={2.5} />}
          {delta}
        </div>
      )}
      {chart}
    </div>
  );
}
